import React from "react";
import { LOGO_URL } from "@/lib/api";

export default function Logo({ size = 44, withText = true, textClassName = "" }) {
  return (
    <div className="flex items-center gap-2.5">
      <div
        className="rounded-full bg-white ring-2 ring-brand/20 shadow-sm overflow-hidden flex items-center justify-center shrink-0"
        style={{ width: size, height: size }}
      >
        <img
          src={LOGO_URL}
          alt="PMR Welfare Foundation"
          className="w-full h-full object-contain p-0.5"
        />
      </div>
      {withText && (
        <div className={`leading-tight ${textClassName}`}>
          <div className="heading font-black text-[15px] tracking-tight">PMR Welfare</div>
          <div className="text-[9px] uppercase tracking-[0.25em] opacity-80 font-bold">Foundation</div>
        </div>
      )}
    </div>
  );
}
